import { loadManifest } from '@angular-architects/module-federation';
import { environment } from './environments/environment';
let env = environment.mcfe;

loadManifest(`/assets/mf.manifest-` + env + `.json`)
	.catch(err => console.error(err))
	.then(_ => import('./bootstrap'))
	.catch(err => console.error(err));

window.addEventListener('error', (event) => {
	if (/Loading chunk [\d]+ failed/.test(event.message)) {
		window.location.reload();
	}
});